import { render, staticRenderFns } from "./PostAssemble.vue?vue&type=template&id=0747ea0a&scoped=true"
import script from "./PostAssemble.vue?vue&type=script&lang=js"
export * from "./PostAssemble.vue?vue&type=script&lang=js"
import style0 from "./PostAssemble.vue?vue&type=style&index=0&id=0747ea0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747ea0a",
  null
  
)

export default component.exports